{
  "loginTitle": "Login",
  "emailPlaceholder": "Email",
  "passwordPlaceholder": "Palavra-passe",
  "loginButton": "Entrar",
  "forgotPassword": "Esqueceu a sua palavra-passe?",
  "signupPrompt": "Não tem uma conta?",
  "signupLink": "Registar",
  "loading": "A carregar...",
  "emailVerifiedSuccessfully": "Email verificado com sucesso!",
  "resetPasswordTitle": "Redefinir Palavra-passe",
  "resetPasswordButton": "Enviar Link de Redefinição",
  "passwordReset": {
    "success": "Se existir uma conta com este email, receberá instruções para redefinir a palavra-passe.",
    "failed": "Não foi possível enviar o email de redefinição da palavra-passe.",
    "error": "Ocorreu um erro ao solicitar a redefinição de palavra-passe. Por favor, tente novamente."
  },
  "passwordResetSuccess": "A sua palavra-passe foi redefinida com sucesso. Por favor, faça login com a sua nova palavra-passe.",
  "passwordResetInvalid": "Link de redefinição de palavra-passe inválido. Por favor, solicite um novo.",
  "passwordResetError": "Ocorreu um erro ao redefinir a sua palavra-passe. O link pode ter expirado.",
  "invalidCredentials": "Email ou palavra-passe incorretos.",
  "networkError": "Não foi possível conectar ao servidor. Verifique a sua ligação e tente novamente.",
  "serverUnavailable": "Servidor indisponível de momento. Tente novamente em instantes.",
  "loginError": "Ocorreu um erro durante o login. Por favor, tente novamente.",
  "privacyInfo": {
    "title": "Os seus dados estão protegidos",
    "body": "Ao continuar, aceita os",
    "termsLink": "Termos de Serviço",
    "privacyLink": "Política de Privacidade"
  },
  "magicLink": {
    "cta": "Entrar com link por email",
    "sentTitle": "Verifica o teu email",
    "sentBody": "Se existir uma conta associada a {{email}}, enviámos um link de acesso. Abre o link para entrares — é válido durante 15 minutos e só pode ser usado uma vez.",
    "sentBodyNoEmail": "Se existir uma conta associada a esse email, enviámos um link de acesso. Abre o link para entrares — é válido durante 15 minutos e só pode ser usado uma vez.",
    "resend": "Reenviar link",
    "resent": "Link reenviado.",
    "backToLogin": "Voltar ao início de sessão",
    "emailRequired": "Introduz o teu email para receberes um link de acesso.",
    "requestError": "Não foi possível enviar o link. Tenta novamente."
  }
} 